export default __webpack_public_path__ + "static/media/gradient-hero.bb854069.svg";